import { Injectable, EventEmitter, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Headers, Http, Response, RequestOptions, URLSearchParams } from '@angular/http';
import { Page } from "Classes/Page";
import { User } from "Classes/User";
import { PermissionsUserRow } from "Classes/GridRows";
import { CookieManagementService as CookieService } from "Services/cookie-management.service";
import { EventService } from "Services/event.service";

@Injectable()
export class FetchDataService {

    private _permissions: number;
    private _access: string[] = []// = ["test1","test2","teamDispatchingUtility","smc","rams","test3","hiJohn"];
    private _superAdmin: boolean = false;
    public _redirectURL: string;

    private _cmDataServiceUrl: string = process.env.SERVICE_URL;
    private _authenticationServiceUrl: string = process.env.AUTHENTICATION_URL;
    public myUrl: string = process.env.PORTAL_URL;
    public teamDispatchingUrl: string = "";
    public _usedSSO: boolean = false;

    private _userControlUrl: string;
    private _email: string;


    private _createUser: string = "Create";
    private _getApps: string = "GetApps";
    private _login: string = "Login";
    private _setRoles: string = "SetRoles";
    private _fetchUsers: string = "GetUsers";
    private _getUserByEmail: string = "GetUserByEmail";
    private _getGisTokenCookie: string = "Gis/GetTokenCookie";
    private _authData: any;
    private _roles: string[];
    public _userGuid: string;

    private _rawAccessToken: string;
    private _rawCmToken: string;
    private _rawAmsToken: string;

    public _dummyUserData: any;

    
    public _defaultApps: string[] = [
        "SMC",
        "SMC 2020",
        "SMC 2021",
        "SMC 2022",
        "SMC 2023",
        "SMC 2024",
        "SMC 2025",
        "SMC Legacy",
        "RAMS",
        "AMS Reachback"
    ];

    public _smcAccess: string = "SMC"
    public _ramsAccess: string = "RAMS"
    public _cmAccess: string = "CM";
    public _amsAccess: string = "AMS";
    private _accessLookup: any = {}
    private _apps: any[];

    private _accessTokenRoles: {
        ams: string;
        superAdmin: string;
        siteAdmin: string;
        admin: string;
    } = {
            ams: "AMS Reachback",
            superAdmin: "Super Admin",
            siteAdmin: "Site Admin",
            admin: "Admin"
        }

    public expireMinutes: number = 10;

    public smcSuperAdmin = false;
    public smcAdmin = false;
    public cmAdmin = true;

    // Permissions
    public superAdmin: number = 0;
    public admin: number = 1;
    public regular: number = 2;

    // Rams Permissions
    public siteAdmin: number = 0;
    public ramsAdmin: number = 1;
    public staff: number = 2;
    public guest: number = 3;

    // Cookies
    public loginData: string = "Login Data";
    public userData: string = "User Data";

    // Globals
    public _users: PermissionsUserRow[] = [];

    constructor(
        private http: Http,
        private cookieService: CookieService,
        private eventService: EventService
    ) {
        this._accessLookup[this._smcAccess] = false;
        this._accessLookup[this._cmAccess] = false;
        this._accessLookup[this._ramsAccess] = false;
        this._accessLookup[this._amsAccess] = false;
        this._userControlUrl = this._cmDataServiceUrl + "api/User/";
    }

    public saveUsers(users: any): void {
        this._users.length = 0;
        for (let user of users) {
            //if (user.email != this._authData.email)
            this.appendUser(user);
        }
    }

    public appendUser(user: any): void {
        user.id = this._users.length + 1;
        this._users.push(new PermissionsUserRow(user));
    }

    public getPermissions(): number {
        return this._permissions;
    }

    public getEmail(): string {
        return this._email;
    }

    public getToken(type: string): string {
        switch (type.toLowerCase().trim()) {
            case "smc":
            case "access": return this._rawAccessToken;
            case "rams":
            case "cm": return this._rawCmToken;
            case "ams": return this._rawAmsToken;
        }
    }



    public setAuthData(accessToken: any, cmToken: any, amsToken: any, authData: any, expireDate: Date): void {
        let data: any = {};
        var minutes = 10;

        if (authData.FName)
            data.firstName = authData.FName;
        if (authData.LName)
            data.lastName = authData.LName;
        if (accessToken) {
            this._accessLookup[this._smcAccess] = true;
            if (accessToken.sub.indexOf("@") >= 0)
                data.email = accessToken.sub;
            data.accessPermission = accessToken.Permission;
            data.user = accessToken.sub;
            this._rawAccessToken = authData.AccessToken;
            this._rawAmsToken = authData.AmsToken || authData.CmToken || authData.AccessToken;
            if (accessToken.roles && accessToken.roles.length)
                this.parseAccessTokenRoles(accessToken, amsToken, expireDate);
        }
        if (cmToken) {
            this._accessLookup[this._ramsAccess] = true;
            if (cmToken.sub.indexOf("@") >= 0 && !data.email)
                data.email = cmToken.sub;
            else if (cmToken.Email && !data.email)
                data.email = cmToken.Email;
            data.user = cmToken.nameid;
            this._rawCmToken = authData.CmToken;
        }
        if (accessToken && cmToken) {
            this._accessLookup[this._cmAccess] = true;
        }
        this._email = data.email;
        //if (amsToken) {
        //    this._accessLookup[this._amsAccess] = true;
        //    this._rawAmsToken = authData.AmsToken;
        //}

        this._permissions = this.getPermissionsFromTokens(accessToken, cmToken);
        data.permission = this._permissions;

        this._authData = data;
        this.cookieService.put("Login", data.email, expireDate);

    }

    public parseAccessTokenRoles(accessToken: any, amsToken: any, expireDate): void {
        if (typeof accessToken.roles === 'string' || accessToken.roles instanceof String) {
            accessToken.roles = [accessToken.roles];
        }
        for (var i = 0; i < accessToken.roles.length; i++) {
            if (accessToken.roles[i] == this._accessTokenRoles.ams || accessToken.roles[i].toLowerCase().indexOf("ams") == 0 || accessToken.roles[i] == this._accessTokenRoles.superAdmin) {
                if (accessToken.roles[i] == this._accessTokenRoles.superAdmin)
                    this._superAdmin = true;
                this._accessLookup[this._amsAccess] = true;
                this.cookieService.put("AmsToken", this._rawAmsToken, expireDate);
            }
        }
    }

    public getPermissionsFromTokens(accessToken: any, cmToken: any): number {
        let accessPermission = this.parseAccessTokenPermissions(accessToken);
        let cmPermission = this.parseCmTokenPermissions(cmToken);
        this.smcSuperAdmin = accessPermission <= this.superAdmin;
        this.smcAdmin = accessPermission <= this.admin;
        this.cmAdmin = cmPermission <= this.ramsAdmin;

        return Math.min(accessPermission, cmPermission);
    }

    private parseAccessTokenPermissions(token): number {
        let permission = this.regular;
        if (token) {
            let roles = token.roles;
            if (typeof roles === 'string' || roles instanceof String) {
                roles = [roles];
            }
            if (roles && roles.length) {
                for (let role of roles) {
                    switch (role) {
                        case this._accessTokenRoles.superAdmin: if (this.superAdmin < permission) permission = this.superAdmin; break;
                        case this._accessTokenRoles.admin: if (this.admin < permission) permission = this.admin; break;
                    }
                }
            }
        }
        return permission;
    }

    private parseCmTokenPermissions(token): number {
        let permission = this.guest;
        if (token) {
            let admin = token.RamsAdmin;
            switch (admin === "true") {
                case true: if (this.ramsAdmin < permission) permission = this.ramsAdmin; break;
                case false: if (this.guest < permission) permission = this.guest; break;
            }
        }
        return permission;
    }

    public getAuthData(): any {
        return this._authData;
    }

    public getAccess(): any {
        return this._accessLookup;
    }

    public getAccessibleApps(): any[] {
        return this._apps.filter(app =>
            (this._accessLookup[app.type]
                && (this._roles.indexOf(app.name) >= 0
                    || this._defaultApps.indexOf(app.name) >= 0))
            || this._superAdmin);
    }

    public getUrl(url): string {
        switch (url) {
            case "cm": return this._cmDataServiceUrl;
            case "authentication": return this._authenticationServiceUrl;
            default: return "";
        }
    }

    public post(url, body, options): Observable<any> {
        return this.postData(url, body, options);
    }

    public get(url, options): Observable<any> {
        return this.getData(url, options);
    }

    public submitCreatedUser(user: User): Observable<any> {
        let url: string = this._userControlUrl + this._createUser;
        let body: any = this.getUserSubmitBody(user);

        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });

        return this.postData(url, body, options);
    }

    public fetchApps(): Observable<any> {

        let url: string = this._userControlUrl + this._getApps;
        let token = this._rawAccessToken;
        if (!token)
            token = this._rawCmToken;
        if (!token)
            token = this._rawAmsToken;
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        });

        let options = new RequestOptions({ headers: headers });

        return this.getData(url, options);
    }

    public getApps(): any[] {
        return this._apps;
    }

    public setApps(apps: { name: string, description: string, type: string }[]): void {
        this._apps = apps;
        if (this._redirectURL) {
            let type;
            let matchedApp = this.getAccessibleApps().filter(a => a.uri.match(/^((http[s]?|ftp):\/)?\/?(([^\/])*)/)[3] === this._redirectURL.match(/^((http[s]?|ftp):\/)?\/?(([^\/])*)/)[3]);
            if (matchedApp && matchedApp.length) {
                type = matchedApp[0].type;
                this.eventService.broadcast(this.eventService._goToPage, this._redirectURL, type); 
            }
        }
    }

    public setUserRoles(roles: string): void {
        try {
            this._roles = JSON.parse(roles);
        } catch (e) {
            this._roles = [];
        }
    }

    public fetchUsers(): void {
        this.getUsers().subscribe(users => {
            if (users && users.length)
                this._users = users;
        }, error => {
            console.error(error);
        });
    }

    public getUserByEmail(): Observable<any> {
        let url: string = this._userControlUrl + this._getUserByEmail;
        let token = this._rawAccessToken;
        if (!token)
            token = this._rawCmToken;
        if (!token)
            token = this._rawAmsToken;
        let headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        });
        let params = new URLSearchParams();
        params.set("email", this._email)
        let options = new RequestOptions({ headers: headers, search: params });

        return this.getData(url, options);
    }


    public getGisTokenCookie(): Observable<any> {

        let url: string = this._authenticationServiceUrl + this._getGisTokenCookie;
        let token = this._rawAccessToken;
        let headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        });

        let params = new URLSearchParams();
        params.set("username", this._email);
        params.set("firstname", this.cookieService.get("FName"));
        params.set("lastname", this.cookieService.get("LName"));

        let options = new RequestOptions({ headers: headers, search: params });

        return this.getData(url, options);

    }

    public getUsers(): Observable<any> {
        let url: string = this._userControlUrl + this._fetchUsers;
        let token = this._rawAccessToken;
        if (!token)
            token = this._rawCmToken;
        if (!token)
            token = this._rawAmsToken;
        let headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        });
        let options = new RequestOptions({ headers: headers });

        return this.getData(url, options);
    }

    public setRoles(ids: string[], roles: string[]) {
        let url: string = this._userControlUrl + this._setRoles;
        let token = this._rawAccessToken;
        if (!token)
            token = this._rawCmToken;
        if (!token)
            token = this._rawAmsToken;
        let headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        });
        let params = new URLSearchParams();
        let r;
        try {
            r = JSON.stringify(roles);
        } catch (e) {
            r = JSON.stringify([]);
        }
        params.set("id", ids[0]);
        params.set("roles", r);

        let options = new RequestOptions({ headers: headers, search: params });

        return this.getData(url, options);
    }


    public updateUserInfo(userInfo: User): Observable<any> {
        return Observable
            .create(observer => observer.next(userInfo))
            .delay(3000);
    }

    public changePassword(userInfo: any): Observable<any> {
        return Observable
            .create(observer => observer.next(true))
            .delay(3000);
    }

    public removeUser(userInfo: User): Observable<any> {
        return Observable
            .create(observer => observer.next(true))
            .delay(3000);
    }

    public authenticateCheckRequirePwReset(userObj: any): Observable<any> {
        return Observable.create(observer => observer.next(false))
    }

    public clearToken(): void {
        //No Token yet, so don't worry aboot it
    }

    private getUserSubmitBody(user: User): any {
        return user;
    }


    // Generic Fetch Functions

    private postData(url, body, options): Observable<any> {
        return this.http.post(url, body, options)
            .map(this.generalMapCallback)
            .finally(this.generalFinallyCallback)
            .catch(this.handleError);
    }

    private getData(url, options): Observable<any> {
        return this.http.get(url, options)
            .map(this.generalMapCallback)
            .finally(this.generalFinallyCallback)
            .catch(this.handleError);
    }

    private generalMapCallback(res) {
        if (!res || res.status == 204)//no data
            return {};
        var body;
        try {
            if (res._body)
                body = res.json();
            else
                body = res._body;
        } catch (e) {
            if ((" " + res.text()).toLowerCase().indexOf(" success") < 0)
                body = { Error: res.text(), Success: false };
            else
                body = { Error: res.text(), Success: true };
            //console.error(e);
        }
        return body || {};

    }

    private registerMapCallback(res) {
        if (!res || res.status == 204)//no data
            return {};
        var body;
        try {
            if (res._body)
                body = res.json();
            else
                body = res._body;
        } catch (e) {
            body = res._body;
            //console.error(e);
        }
        return body || {};

    }

    private generalFinallyCallback() {
        //Do something probably
    }

    private handleError(error: any, caught?: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg: string;
        if (error.status == 400)//bad request suggest invalid username and password
            errMsg = error._body;
        else {
            errMsg = (error.message) ? error.message :
                error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        }
        //console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Services/fetch-data.service.ts